<div style="margin-bottom: 20px ;">
  <app-progress-bar [indexItem]=itemNumber [progressBarState]=progressBarName [progressBarArray1]=progressBarArray1>
  </app-progress-bar>
</div>

<div class="section">


  <div class="content" style="margin: 10px 16px">
    <p class="sub-text-600-bold" style="display: inline-block;margin-top: 10px;">Extract Batch Key From Cloud</p>
  </div>
  <div class="content" style="margin: 0px 16px;padding-bottom: 21px; border-bottom: 2px solid rgba(5, 5, 5, 0.12);">
    <div style="display: inline-block;">
      <label class="text_12" style="display: block;margin-bottom: 10px;">Cloud Instance <span
          style="color: red;">*</span></label>
      <select class="select-css" [(ngModel)]="selectedInstance" name="instanceName"
        (change)="onInstanceChange(selectedInstance)">
        <option [ngValue]="null">Select</option>
        <option *ngFor="let instance of instanceList" [ngValue]="instance">{{instance.INSTANCE}}</option>
      </select>
    </div>
  </div>

  <div class="content" style="margin: 0px 16px;" *ngIf="this.selectedInstance != null">
    <div *ngFor="let item of tracks; let i = index" (click)="showArray[i]=!showArray[i]"
      style="border-bottom: 1px solid #c4c4c4; padding-top: 10px; padding-bottom: 10px;">
      <span>
        <span *ngIf="!showArray[i]"><img alt="image" src="./assets/Expand-Column.svg"
            class="expand-button"></span>
        <span *ngIf="showArray[i]"><img alt="image" src="./assets/Expand-Column-svg.svg"
            class="expand-button"></span><button mat-button>{{item}}</button>
      </span>
      <div *ngIf="showArray[i]" class="buttons-i">
        <span *ngFor="let configItem of configData">
          <ng-container *ngIf="item == configItem.TRACK">
            <span (click)="configPopUp($event, configItem)">
              <div style="display: inline-block; margin-right: 32px;">
                <mat-checkbox [checked]="configItem.saveStatus" [disableRipple]="true"
                  (click)="$event.preventDefault()"> <span mat-button>{{configItem.APPLICATION}}</span>
                </mat-checkbox>
              </div>
            </span>
          </ng-container>

        </span>
      </div>
    </div>
  </div>

  <div class="content-disabled" style="margin: 0px 16px;" *ngIf="this.selectedInstance == null">
    <div *ngFor="let item of tracks; let i = index"
      style="border-bottom: 1px solid #c4c4c4; padding-top: 10px; padding-bottom: 10px;">
      <span><span><img alt="image" src="./assets/Accordion-Disabled.svg" style="float: right; vertical-align: middle;   -ms-transform: rotate(180deg);
        transform: rotate(180deg); margin-top:5px;"></span><button mat-button>{{item}}</button> </span>
    </div>
  </div>
</div>
